import React, {Component} from 'react';
import '../css/views/booking-common.css';
import '../css/theme/mainContent.css';
import '../css/theme/forms.css';
import '../css/theme/forms-block.css';
import '../css/theme/buttons.css';
import { Booking } from '../types/Booking';
import { AccountWithUserType } from '../util/AccountUtils';

interface SupplierBookingActionButtonsProps {
    booking: Booking;
    account: AccountWithUserType;
    changeViewHandler: (view: string, booking: Booking) => void;
    cancelBooking: (bookingId: string) => void;
}

class SupplierBookingActionButtons extends Component<SupplierBookingActionButtonsProps> {

    static showCancel(account: AccountWithUserType, booking: Booking): boolean {
        const ONE_HOUR = 60 * 60 * 1000;
        const TWENTY_FOUR_HOURS = 24 * ONE_HOUR;
        const timeBeforeBookingStart = new Date(booking.startDate).getTime() - (new Date()).getTime();
        return (timeBeforeBookingStart > TWENTY_FOUR_HOURS && ['OWNER', 'GATEMANAGER'].includes(account.userType || ''));
    }

    render () {
        return (
            <div className="ss-booking-button-container">
                <button className="ss-button-primary"
                        onClick={() => this.props.changeViewHandler('check-in-out-head', this.props.booking)}>
                    Check - In</button>
                {
                    SupplierBookingActionButtons.showCancel(this.props.account, this.props.booking) ?
                        <button className="ss-button-danger"
                                onClick={() => this.props.cancelBooking(this.props.booking.id)}
                        >Cancel</button>
                        :
                        ''
                }
            </div>
        )
    }
}

export default SupplierBookingActionButtons;
